import NoteTaskModal from './NoteTaskModal';

export default function AddTaskModal({ target, onClose, onSaved, projectId }) {
  return (
    <NoteTaskModal
      type="task"
      mode="add"
      target={target}
      projectId={projectId}
      onClose={onClose}
      onSaved={onSaved}
    />
  );
}
